export default __webpack_public_path__ + "static/media/logo-metabase.b4bb45b6.png";